// Tab bar flottante du shell mobile Life — DA V3 validée : effet verre,
// 4 onglets vectoriels + FAB « + » central ouvrant la feuille d'ajout rapide.
// « Aujourd'hui » et « Profil » sont fixes ; les 2 slots du milieu sont
// personnalisables depuis Profil → Personnaliser la barre (voir tabCatalog.js).
// Réf. : DEV/mockup_mobile_navigation_v3.html
import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
  getCatalogEntry,
  loadTabSlots,
  TABS_CHANGED_EVENT,
} from './tabCatalog'

const HOME_TAB = {
  key: 'home',
  path: '/',
  label: ['tabs.today', "Aujourd'hui"],
  icon: (
    <svg viewBox="0 0 24 24">
      <path d="M3 10.5L12 3l9 7.5" />
      <path d="M5 9.5V21h14V9.5" />
    </svg>
  ),
  isActive: (p) => p === '/',
}

const PROFILE_TAB = {
  key: 'profil',
  path: '/profil',
  label: ['tabs.profile', 'Profil'],
  icon: (
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 3.5-6.5 8-6.5s8 2.5 8 6.5" />
    </svg>
  ),
  isActive: (p) => p.startsWith('/profil'),
}

const MobileTabBar = ({ addOpen, onToggleAdd }) => {
  const { t } = useTranslation(['layout', 'common'])
  const navigate = useNavigate()
  const location = useLocation()
  const path = location.pathname

  // Slots personnalisés, rechargés quand le Profil enregistre un changement.
  const [slots, setSlots] = useState(loadTabSlots)
  useEffect(() => {
    const reload = () => setSlots(loadTabSlots())
    window.addEventListener(TABS_CHANGED_EVENT, reload)
    return () => window.removeEventListener(TABS_CHANGED_EVENT, reload)
  }, [])

  const [slot1, slot2] = slots.map(getCatalogEntry)

  const go = (to) => {
    if (addOpen) onToggleAdd(false)
    navigate(to)
    window.scrollTo(0, 0)
  }

  const renderTab = (tab) => (
    <button
      key={tab.key}
      className={tab.isActive(path) ? 'lm-actif' : ''}
      onClick={() => go(tab.path)}
    >
      {tab.icon}
      {t(tab.label[0], tab.label[1])}
    </button>
  )

  // Disposition maquette : 2 onglets — FAB — 2 onglets.
  return (
    <div className="lm-tabwrap">
      <nav className="lm-tabs">
        {[HOME_TAB, slot1].map(renderTab)}
        <button
          className={`lm-fab${addOpen ? ' lm-ouvert' : ''}`}
          aria-label={t('tabs.quickAdd', 'Ajout rapide')}
          onClick={() => onToggleAdd(!addOpen)}
        >
          <svg viewBox="0 0 24 24">
            <path d="M12 5v14M5 12h14" />
          </svg>
        </button>
        {[slot2, PROFILE_TAB].map(renderTab)}
      </nav>
    </div>
  )
}

export default MobileTabBar
